


























// libs
import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';

// interface
import { Patient } from '@/models/patient';
import { User } from '@/models/user';

// components
import UpdatePatientInfoModal from '@/components/v2/patient/about/patient_info/UpdatePatientInfoModal.vue';
import UpdateDeliveryAddressModal from '@/components/v2/patient/about/patient_info/UpdateDeliveryAddressModal.vue';

@Component({
  components: {
    UpdatePatientInfoModal,
    UpdateDeliveryAddressModal,
  },
})
export default class EditPatient extends Vue {
  @State((state) => state.patient_detail.data) patient!: Patient;
  @State((state) => state.auth.currentUser) currentUser!: User;

  private get editPatientModalRef() {
    return this.$refs.editPatientModal as any;
  }

  private get canEditUser() {
    return this.currentUser.isCSRole;
  }

  private get canEditDeliveryAddress() {
    return this.currentUser.isSuperAdminRole || this.currentUser.isCSRole;
  }

  private get editDeliveryAddressModalRef() {
    return this.$refs.editDeliveryAddressModal as any;
  }

  private showEditPatientModal() {
    this.editPatientModalRef.show();
  }

  private showEditDeliveryAddressModal() {
    this.editDeliveryAddressModalRef.show();
  }
}
